import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Inject, HostListener, Injector } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgxQrcodeElementTypes } from '@techiediaries/ngx-qrcode';
import { Platform } from '@angular/cdk/platform';
import { BuroService } from 'src/app/services/buro.service';
import { IdentityVerificationComponent } from '../identity-verification.component';




@Component({
  selector: 'app-identity-options',
  templateUrl: './identity-options.component.html',
  styleUrls: ['./identity-options.component.scss'],
  animations: [
    trigger('slideInOut', [
      state('in', style({ transform: 'translateX(0)' })),
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('300ms ease-in-out')
      ]),
      transition(':leave', [
        animate('300ms ease-in-out', style({ transform: 'translateX(-100%)' }))
      ])
    ]),
    trigger('slideIn', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)' }),
        animate('300ms ease-in-out', style({ transform: 'translateX(0)' }))
      ])
    ])
  ]
})
/**
 * Represents the Identity Options component.
 * This component is responsible for displaying different options for identity verification, such as generating a QR code or sending an email.
 * It also handles the logic for opening the Identity Verification component in a modal.
 */
export class IdentityOptionsComponent {

  elementType: NgxQrcodeElementTypes = NgxQrcodeElementTypes.URL;
  url!: string;
  value: string = '';
  showContentQR: boolean = false;
  showContentMail: boolean = false;
  emailSentSuccess: boolean = false;
  public screenWidth: any = window.innerWidth;
  public screenHeight: any = window.innerHeight;
  email: string = '';
  onboardingStatusIncode: string = '';
  onboardingStatusIncodeEndorsment: string = '';
  showErrorVerify!: boolean;
  stepService: any;
  platform: Platform;
  buroService: BuroService;
  onboardingFinishedCount: number = 0;


  constructor(
    @Inject(MAT_DIALOG_DATA) public dataParam: any,
    public dialog: MatDialog,
    public dialogRefOpt: MatDialogRef<IdentityOptionsComponent>,
    public dialogRefIncode: MatDialogRef<IdentityVerificationComponent>,
    private injector: Injector
  ) {
    this.platform = this.injector.get<Platform>(Platform);
    this.buroService = this.injector.get<BuroService>(BuroService);
    this.url = dataParam.url;
    this.email = dataParam.email;
    this.stepService = dataParam.stepService;
  }


  /**
   * Button back to show the menu options
   * @memberof IdentityOptionsComponent
   * @author victor.mendez
   */
  buttonBack(): void {
    this.showContentQR = false;
    this.showContentMail = false;
  }

  /**
   * Generate QR Code 
   * show the QR code and hide other options
   * @memberof IdentityOptionsComponent
   * @author victor.mendez
   */
  generateQRCode(): void {
    this.value = this.url;
    this.showContentQR = true;
    this.showContentMail = false;
  }

  /**
   * Send by email
   * show the email and hide other options
   * @memberof IdentityOptionsComponent
   */
  sendByEmail(): void {
    this.showContentQR = false;
    this.showContentMail = true;


    /* 
    TODO: Implement email sending
    this.buroService.sendEmailIdentityVerification(this.email, this.url).subscribe({
      next: (resp) => {
        this.emailSentSuccess = true;
        console.log('Email sent successfully');
      },
      error: (error: any) => {
        console.error('Error sending email');
        // hace falta generar un flujo de error
      }
    }); */
    // Simulate email sending process
    setTimeout(() => {
      this.emailSentSuccess = true;
    }, 3000);
  }

  /**
   * Open modal incode iframe widget
   * @memberof IdentityOptionsComponent
   * @author victor.mendez
   */
  openModalIncode(): void {
    this.showContentMail = false;
    this.showContentQR = false;
    this.dialogRefOpt.close();
    this.dialogRefIncode = this.dialog.open(IdentityVerificationComponent,
      {
        disableClose: true,
        width: this.isMobile() ? '100vw' : 'calc(100% - 80px)',
        height: this.isMobile() ? '100vh' : 'calc(100% - 80px)',
        maxWidth: "100%",
        maxHeight: "100%",
        data: {
          url: this.url
        }
      });
  }

  /**
   * Check if the device is mobile
   * @return {*} 
   * @memberof IdentityOptionsComponent
   */
  isMobile() {
    return this.screenWidth < 768 || this.platform.ANDROID || this.platform.IOS
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(): void {
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
    this.isMobile();
  }

}


